import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {PlatformsService} from '../../../../core/services/platforms.service';
import {fuseAnimations} from '../../../../core/animations';
import {MatDialog} from '@angular/material/dialog';
import {EditPlatformModal} from './edit-platform/edit-platform.modal';
import { fromEvent as observableFromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'platforms',
    templateUrl: './matrixPlatforms.component.html',
    styleUrls: ['./matrixPlatforms.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class MatrixPlatformsComponent implements OnInit {
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  platforms = [];
  matrixPlatforms = [];
  dataSource = [];
  displayedColumns = [ 'organization_title' ];
  _pageIndex = 0;
  _perPage = 50;
  _search = '';
  _total = 0;

  constructor(public platformsService: PlatformsService, public dialog: MatDialog,
              private spinner: NgxSpinnerService) {
  }

  ngOnInit() {
    this.getPlatforms();
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(1500),
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this._search = this.filter.nativeElement.value;
          localStorage.setItem('matrixPlatformSearch', this.filter.nativeElement.value);
          this.paginator.firstPage();
          this.cleanScrollFU();
          this.getMatrixPlatform();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this._search){
          this._search = '';
          localStorage.setItem('matrixPlatformSearch', this.filter.nativeElement.value);
          this.paginator.firstPage();
          this.cleanScrollFU();
          this.getMatrixPlatform();
        }
      });
  }

  cleanScrollFU() {
    let table = document.getElementById('matrixPlatformPage');
    if (table) {
      table.scrollTop = 0;
      localStorage.setItem('matrixPlatformPage' , '0');
    }
  }

  getPlatforms() {
    this.displayedColumns = [ 'organization_title' ];
    this.matrixPlatforms = [];
    this.dataSource = [];
    this.platforms = [];
    this.platformsService.getPlatforms().subscribe((res: any) => {
      this.platforms = res.filter(platform => platform.status);
      if (this.platforms && this.platforms.length) {
        for (let platform of this.platforms) {
          let ifExists = this.displayedColumns.filter(el => el.split('_')[0] === platform.title);
          if (ifExists.length) {
            this.displayedColumns.push(platform.title + '_' + ifExists.length);
          } else {
            this.displayedColumns.push(platform.title);
          }
        }
        this.displayedColumns.push('edit');
      }
      this.getMatrixPlatform();
    });
  }

  getMatrixPlatform() {
    this.spinner.show();
    this.platformsService.getMatrixPlatform(this._pageIndex + 1, this._perPage, this._search).subscribe((res: any) => {
      this.matrixPlatforms = res.organizations;
      this._total = res.pagination.total;
      if (this.matrixPlatforms && this.matrixPlatforms.length) {
        let data = [];
        for (let matrixPlatform of this.matrixPlatforms) {
          let obj = {
            organization_title: matrixPlatform.name
          };
          for (let platform of this.platforms) {
            if (matrixPlatform.matrixPlatform && matrixPlatform.matrixPlatform.length) {
              let plat = matrixPlatform.matrixPlatform.find(el => +el.platformId === +platform.id);
              if (plat) {
                obj[platform.title] = plat.enable;
              } else {
                obj[platform.title] = false;
                let platObj = {
                  enable: false,
                  platform: platform
                };
                matrixPlatform.matrixPlatform.push(platObj);
              }
            } else {
              obj[platform.title] = false;
              let platObj = {
                enable: false,
                platform: platform
              };
              matrixPlatform.matrixPlatform.push(platObj);
            }
            obj['edit'] = matrixPlatform;
          }
          data.push(obj);
        }
        this.dataSource = data;
        console.log(this.dataSource);
      } else {
        this.dataSource = [];
      }
      this.spinner.hide();
    });
  }

  editPlatform(data) {
    const dialogRef = this.dialog.open(EditPlatformModal , {
      width: '500px' ,
      data: data
    });

    dialogRef.afterClosed().subscribe(res => {
      this.getPlatforms();
    });
  }

  changePageEmitter(e) {
    this._pageIndex = e.pageIndex;
    this._perPage = e.pageSize;
    this.cleanScrollAdmin();
    this.getPlatforms();
  }

  cleanScrollAdmin() {
    let table = document.getElementById('matrixPlatformPage');
    if (table) {
      table.scrollTop = 0;
    }
  }
}
